import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MaterialGridViewItem } from '@classes/material-grid-view-item';
import { MessageBoxParameter } from '@classes/message-box-parameter';
import { Ship } from '@classes/ship';
import { MessageBox } from '@components/message-box/message-box.component';
import { Role } from '@enums/role.enum';
import { TranslateService } from '@ngx-translate/core';
import { ShipService } from 'app/core/services/ship.service';
import { UiService } from 'app/core/services/ui.service';
import { ShipDetailComponent } from '../ship-detail/ship-detail.component';

@Component({
  selector: 'app-ship-grid',
  templateUrl: './ship-grid.component.html',
  styleUrls: ['./ship-grid.component.scss']
})
export class ShipGridComponent implements OnInit {

  @Input() set filter(filter: string) {
    this.dataSource.filter = filter;
  };
  
  dataSource = new MatTableDataSource<Ship>();
  pageSizeOptions = [25, 50, 100];
  selectedRowID: string;
  displayedColumns: string[] = [
    'name',
    'eni',
    // 'modifiedDate',
    // 'userName',
    'action'
  ];

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) MatPaginatorShip: MatPaginator;

  Role = Role;

  constructor(
    public shipService: ShipService,
    public uiService: UiService,
    public dialog: MatDialog,
    public translateService: TranslateService
  ) { }

  ngOnInit() {
    this.getShips();
  }
  getShips() {
    this.uiService.addRouteLoading();
    this.shipService.getShips(true).subscribe(siteMode => {
      this.dataSource.data = siteMode;
      this.uiService.removeRouteLoading();
    }, error => {
      console.error(error);
      this.uiService.removeRouteLoading();
    });
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.MatPaginatorShip;
    this.dataSource.sortingDataAccessor = (data: any, sortHeaderId: string): string => {
      if (typeof data[sortHeaderId] === 'string') {
        return data[sortHeaderId].toLocaleLowerCase();
      }

      return data[sortHeaderId];
    };
  }

  selectItemClick(item: Ship) {
    this.selectedRowID = item.id || '';
  }
  editElement(item: Ship) {
    const data = new Ship({
      id: item.id || "",
      name: item.name || "",
      eni: item.eni || "",
    });
    const dialogRef = this.dialog.open(ShipDetailComponent, {
      data,
      hasBackdrop: true
    });
    dialogRef.afterClosed().subscribe(success => {
      if (success) {
        this.getShips();
      }
    });
  }

  onDelete(item: Ship) {
    if (item && item.id) {

      const messageBoxParameter = new MessageBoxParameter();

      messageBoxParameter.message = this.translateService.instant('ship.confirm-delete');
      messageBoxParameter.dialog = this.dialog;
      messageBoxParameter.title = 'Confirmation';
      messageBoxParameter.buttons = ['yes', 'no'];
      messageBoxParameter.width = "400px";

      MessageBox.show(messageBoxParameter).subscribe(mbResult => {
        if (mbResult && mbResult.value) {
          this.uiService.addRouteLoading();
          this.shipService.deleteShip(item?.id || "").subscribe(data => {
            this.uiService.displayMessageToast('ship.success-delete');
            this.uiService.removeRouteLoading();
            this.getShips();
          }, error => {
            console.error(error);
            this.uiService.removeRouteLoading();
          });
        }
      });
    }
  }

}
